import {combineReducers} from 'redux';
import type {IntlState} from './Intl/IntlReducer';
import {intl} from './Intl/IntlReducer';

import type {PaymentInfoParamState} from "./PaymentInfoParam/PaymentInfoParamReducer";
import {paymentInfoParam} from "./PaymentInfoParam/PaymentInfoParamReducer";

import type {PaymentErrorParamState} from "./PaymentErrorParam/PaymentErrorParamReducer";
import {paymentErrorParam} from "./PaymentErrorParam/PaymentErrorParamReducer";

import type {PaymentSuccessParamState} from "./PaymentSuccessParam/PaymentSuccessParamReducer";
import {paymentSuccessParam} from "./PaymentSuccessParam/PaymentSuccessParamReducer";

export const appReducer = combineReducers({
   intl,
   paymentInfoParam,
   paymentErrorParam,
   paymentSuccessParam
});

export type AppState = {
   intl: IntlState,
   paymentInfoParam: PaymentInfoParamState,
   paymentErrorParam: PaymentErrorParamState,
   paymentSuccessParam: PaymentSuccessParamState
};
